import { Checkbox, FormControlLabel, Stack, Typography } from '@mui/material'
import { CertificateMultipleChoiceAnswer, CertificateMultipleChoiceQuestion } from 'src/types/CertificateQuestion'

type MultipleChoiceAnswerTableProps = {
    question: CertificateMultipleChoiceQuestion
    answer: CertificateMultipleChoiceAnswer
    onAnswerUpdate: (answers: CertificateMultipleChoiceAnswer, isValidAnswer: boolean) => unknown
}

export function MultipleChoiceAnswerTable({ onAnswerUpdate, answer, question }: MultipleChoiceAnswerTableProps) {
    const updateAnswer = (id: string, checked: boolean) => {
        const answers = { ...answer.answers, [id]: checked }

        let isAnswerValid = false
        for (const a of Object.values(answers)) {
            if (a === true) {
                isAnswerValid = true
                break
            }
        }

        onAnswerUpdate({ ...answer, answers }, isAnswerValid)
    }

    const isAnswerOptionChecked = (id: string) => !!answer.answers[id]

    return (
        <>
            <Typography variant="caption">Wähle ein oder mehrere Antworten aus:</Typography>
            <Stack spacing={2}>
                {question.answers.map((a) => (
                    <div key={a._id}>
                        <FormControlLabel
                            control={
                                <Checkbox checked={isAnswerOptionChecked(a._id)} onChange={(e) => updateAnswer(a._id, e.target.checked)} />
                            }
                            label={a.text}
                        />
                    </div>
                ))}
            </Stack>
        </>
    )
}
